import gettext from '@sdk/lang/gettext';
import Modal from '@sdk/components/ui/modal/Modal';
import Text16 from '@sdk/components/ui/typography/Text16';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import ExclamationMarkIcon from '@web/assets/svg/UI/exclamation-mark.svg';
import {
  CustomModalBody,
  IconWrapper,
} from '@web/timeClock/ClockInNotAvailableModal/clockInNotAvailableModal.styles';
import { getUpcomingShiftStartDateString } from '@web/timeClock/ClockInNotAvailableModal/clockInNotAvailableModal.utils';

type Props = {
  isVisible: boolean;
  upcomingShiftStartDate: Date;
  usTimeFormat: boolean;
  onClose: VoidFunction;
};

const ClockInNotAvailableModal = ({
  isVisible,
  upcomingShiftStartDate,
  usTimeFormat,
  onClose,
}: Props) => {
  if (!isVisible) return null;

  return (
    <Modal isVisible={isVisible} onDismiss={onClose} closePositionRight={12} closePositionTop={12}>
      <CustomModalBody justifyContent="center" alignItems="center">
        <IconWrapper>
          <ExclamationMarkIcon />
        </IconWrapper>
        <Text16 pTop={20} semiBold pBottom={5} themeColor={ThemeColorType.gray}>
          {gettext('You are in too early')}
        </Text16>
        <Text16 semiBold themeColor={ThemeColorType.iconGray}>
          {gettext(`Your shift starts at %(upcomingShiftStartDateString)s.`, {
            upcomingShiftStartDateString: getUpcomingShiftStartDateString({
              upcomingShiftStartDate,
              usTimeFormat,
            }),
          })}
        </Text16>
      </CustomModalBody>
    </Modal>
  );
};

export default ClockInNotAvailableModal;
